// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingConditionValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';
import { assign, isFunction, get } from 'lodash/fp';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import InputByDataType from 'share/components/controls/Izenda.InputByDataType';

const {CONDITION_TYPE, DATA_TYPE, INPUT_DATA_TYPE, BOOLEAN_OPTION} = constants;

@observer
class ConditionalFormattingConditionValue extends Component {
  constructor(props) {
    super(props);
  }

  render(){
    const {props: {localization, condition}} = this;

    const conditionType = condition.type;
    if(!conditionType 
      || conditionType == CONDITION_TYPE.ALL_VALUES.value
      || conditionType == CONDITION_TYPE.BLANK.value
      || conditionType == CONDITION_TYPE.NULL.value)
      return null;

    const getInputTypeByDataType =(dataType) => {
      switch (dataType) {
        case DATA_TYPE.TEXT:
          return INPUT_DATA_TYPE.TEXT;
        case DATA_TYPE.MONEY:
        case DATA_TYPE.NUMERIC:
          return INPUT_DATA_TYPE.NUMBER;
        case DATA_TYPE.BOOLEAN:
          return INPUT_DATA_TYPE.SELECT;
        case DATA_TYPE.DATETIME:
          return INPUT_DATA_TYPE.DATETIME;
        case DATA_TYPE.TIME:
          return INPUT_DATA_TYPE.TIME;
        default:
          return INPUT_DATA_TYPE.TEXT;
      }
    }

    const getDateTimeFormatData = (dateTimeFormatDataFn) => {
      return isFunction(dateTimeFormatDataFn) ? dateTimeFormatDataFn() : dateTimeFormatDataFn;
    }

    const conditionField = condition.conditionField;
    const conditionFieldDataType = conditionField.type; 
    const dateTimeFormatData = conditionField.dateTimeFormatData;
    const inputDataType = getInputTypeByDataType(conditionFieldDataType);

    const prepareProps = () => {
      let inputCtrlProps = {};
      if(inputDataType === INPUT_DATA_TYPE.DATETIME || inputDataType === INPUT_DATA_TYPE.TIME){
        const dateTimeFormatDataResult = getDateTimeFormatData(dateTimeFormatData);
        inputCtrlProps = assign(inputCtrlProps, {groupByDateTime: get('groupBy', dateTimeFormatDataResult)});
      }
      if (conditionType === CONDITION_TYPE.RANGE_PERCENT.value && inputDataType === INPUT_DATA_TYPE.NUMBER) {
        inputCtrlProps = assign(inputCtrlProps, {min: 0, max: 100});
      } else if (inputDataType === INPUT_DATA_TYPE.SELECT) {
        inputCtrlProps = assign(inputCtrlProps, BOOLEAN_OPTION);
      }
      return inputCtrlProps;
    }

    if(conditionType == CONDITION_TYPE.RANGE_PERCENT.value || conditionType == CONDITION_TYPE.RANGE_VALUE.value){
      const onValueFromChange = (newValue) => {
        condition.value.from = newValue.value;
      }

      const onValueToChange = (newValue) => {
        condition.value.to = newValue.value;
      }

      return(
        <GridLayout.Row>
          <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_CONDITION_VALUE')}</GridLayout.Col>
          <GridLayout.Col cols={4}>
            <InputByDataType type={inputDataType} onChange={onValueFromChange} value={condition.value.from} {...prepareProps()}/>
          </GridLayout.Col>
          <GridLayout.Col className="u_controlHeight u_textCenter" cols={1}><span>-</span></GridLayout.Col>
          <GridLayout.Col cols={4}>
            <InputByDataType type={inputDataType} onChange={onValueToChange} value={condition.value.to} {...prepareProps()}/>
          </GridLayout.Col>
        </GridLayout.Row>
      );
    } else{
      const onValueChange = (newValue) => {
        condition.value = newValue.value;
      }

      return (
        <GridLayout.Row>
          <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_CONDITION_VALUE')}</GridLayout.Col>
          <GridLayout.Col cols={9}>
            <InputByDataType value={condition.value} onChange={onValueChange} type={inputDataType} {...prepareProps()}/>
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }
  }
}

export default ConditionalFormattingConditionValue;


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingConditionValue.jsx